enum PartnerLinkType {
  EXT_PARTNER_PARTNER = 'external_partner_partner',
}
export { PartnerLinkType };
